import { useState } from "react";
import { packageItems } from "@/mocks/home";

const boxCoverImg =
  "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/0ffb9901-b46b-46cc-bfc2-58f7e2413667_compressed_-.webp";
const flatlayImg =
  "https://storage.helloreaddy.io/project_files/426a1197-20a9-430d-8146-3da1fd5d33df/23075fad-fbce-4829-9271-82ff48f5bee8_compressed_ChatGPT-Image-2026-8-1--03_30_27.webp";

export default function PackageBox() {
  const [activeIdx, setActiveIdx] = useState<number | null>(null);
  const activeItem = activeIdx !== null ? packageItems[activeIdx] : null;

  return (
    <section id="package" className="w-full bg-background-50 py-14 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* 상단 텍스트 */}
        <div className="text-center mb-10 md:mb-16">
          <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
            WHAT'S IN THE BOX
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight break-keep">
            필요한 모든 것,<br className="hidden sm:block" /> 하나의 상자에.
          </h2>
          <p className="mt-4 text-foreground-700 leading-relaxed max-w-xl mx-auto">
            풀페이스부터 오픈페이스까지. X9 PRO 패키지 하나면 별도 액세서리 없이
            바로 설치할 수 있습니다.
          </p>
        </div>

        {/* 메인 비주얼: 박스 + 평면도 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-3 md:gap-6 mb-10 md:mb-16">
          {/* 오렌지 박스 — 세로 프리미엄 샷 */}
          <div className="lg:col-span-4 rounded-2xl overflow-hidden bg-[#E85D04] border border-background-200/70">
            <div className="relative h-[320px] md:h-[460px]">
              <img
                src={boxCoverImg}
                alt="LRGS1 X9PRO 프리미엄 패키지 박스"
                className="w-full h-full object-contain object-center"
              />
              <div className="absolute bottom-4 left-4 right-4">
                <div className="rounded-xl bg-background-50/90 backdrop-blur-sm border border-background-200/70 px-4 py-3">
                  <div className="text-[11px] tracking-[0.28em] text-foreground-500 font-heading">
                    LRGS1 PREMIUM BOX
                  </div>
                  <div className="font-heading text-lg font-bold text-foreground-950 mt-0.5">
                    X9 PRO
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 구성품 평면도 — 전체 샷 */}
          <div className="lg:col-span-8 rounded-2xl overflow-hidden bg-white border border-background-200/70">
            <div className="relative aspect-[4/3] md:aspect-auto md:h-[460px]">
              <img
                src={flatlayImg}
                alt="X9 PRO 전체 구성품"
                className="w-full h-full object-contain object-center p-3 md:p-6"
              />
              <div className="absolute top-4 right-4 flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground-950 text-background-50 text-xs font-semibold tracking-widest">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                9 ITEMS
              </div>
            </div>
          </div>
        </div>

        {/* 하단: 구성품 리스트 + 디테일샷 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          {/* 구성품 번호 리스트 */}
          <div className="lg:col-span-8">
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-archive-2-line text-sm"></i>
              </span>
              구성품 상세
            </h3>
            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {packageItems.map((it, idx) => (
                <li
                  key={it.id}
                  onMouseEnter={() => setActiveIdx(idx)}
                  onMouseLeave={() => setActiveIdx(null)}
                  onClick={() => setActiveIdx(activeIdx === idx ? null : idx)}
                  className={`
                    flex flex-col rounded-xl border px-4 py-3.5 cursor-default
                    transition-all duration-200
                    ${
                      activeIdx === idx
                        ? "bg-primary-50 border-primary-200 shadow-sm"
                        : "bg-background-100 border-background-200/70"
                    }
                  `}
                >
                  <div className="flex items-center gap-3 w-full">
                    <span
                      className={`
                        w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0
                        transition-colors duration-200
                        ${
                          activeIdx === idx
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }
                      `}
                    >
                      {idx + 1}
                    </span>
                    <span className="flex-1 text-sm font-medium text-foreground-900">
                      {it.label}
                    </span>
                    <span className="text-xs font-heading font-semibold text-foreground-500 tracking-widest whitespace-nowrap">
                      x{it.qty}
                    </span>
                  </div>

                  {/* 모바일: 아이템 클릭하면 바로 아래에 사진 펼쳐짐 */}
                  {activeIdx === idx && (
                    <div className="lg:hidden mt-3 w-full">
                      <div className="rounded-xl overflow-hidden bg-white border border-background-200/70">
                        <div className="aspect-[4/3] w-full">
                          <img
                            src={it.detailImage}
                            alt={it.label}
                            className="w-full h-full object-contain p-3"
                          />
                        </div>
                        <div className="px-3 py-2.5 border-t border-background-200/70">
                          <div className="flex items-center gap-2 mb-1">
                            <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-[10px] font-bold">
                              {idx + 1}
                            </span>
                            <span className="text-sm font-semibold text-foreground-950">
                              {it.label}
                            </span>
                            <span className="text-xs font-heading font-semibold text-foreground-500 tracking-widest whitespace-nowrap">
                              x{it.qty}
                            </span>
                          </div>
                          <div className="text-xs text-foreground-600 leading-relaxed">
                            {it.detailDesc}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* PC: 오른쪽 클로즈업 디테일샷 */}
          <div className="hidden lg:block lg:col-span-4">
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-4 flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-focus-3-line text-sm"></i>
              </span>
              상세 클로즈업
            </h3>
            <div className="rounded-2xl overflow-hidden bg-white border border-background-200/70 transition-all duration-300">
              <div className="relative h-[240px] md:h-[280px]">
                {activeItem ? (
                  <img
                    src={activeItem.detailImage}
                    alt={activeItem.label}
                    className="w-full h-full object-contain object-center p-4 transition-opacity duration-300"
                    key={activeItem.id}
                  />
                ) : (
                  <div className="w-full h-full flex flex-col items-center justify-center text-foreground-400 gap-3">
                    <i className="ri-mouse-line text-3xl"></i>
                    <span className="text-sm">좌측 구성품에 마우스를 올려보세요</span>
                  </div>
                )}
              </div>
              <div className="px-4 py-3 border-t border-background-200/70 transition-all duration-300">
                {activeItem ? (
                  <>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-[10px] font-bold">
                        {activeIdx! + 1}
                      </span>
                      <span className="text-sm font-semibold text-foreground-950">
                        {activeItem.label}
                      </span>
                      <span className="text-xs font-heading font-semibold text-foreground-500 tracking-widest whitespace-nowrap">
                        x{activeItem.qty}
                      </span>
                    </div>
                    <div className="text-xs text-foreground-600 mt-1">
                      {activeItem.detailDesc}
                    </div>
                  </>
                ) : (
                  <div className="text-center text-xs text-foreground-400 py-2">
                    구성품을 선택하면 상세 정보가 표시됩니다
                  </div>
                )}
              </div>
            </div>

            {/* 요약 카드 */}
            <div className="mt-4 rounded-xl bg-background-100 border border-background-200/70 px-4 py-4">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700">
                  <i className="ri-shield-check-line"></i>
                </span>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">
                    정품 보증 포함
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">
                    구매일로부터 1년 무상 A/S
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
